import { render, staticRenderFns } from "./DeclaredValuePackDetails.vue?vue&type=template&id=2f33dc7a&scoped=true"
import script from "./DeclaredValuePackDetails.vue?vue&type=script&lang=ts"
export * from "./DeclaredValuePackDetails.vue?vue&type=script&lang=ts"
import style0 from "./DeclaredValuePackDetails.vue?vue&type=style&index=0&id=2f33dc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33dc7a",
  null
  
)

export default component.exports